import React from 'react'

import TaskTrayTask from './task-view/task-view'
import TaskTrayChat from './chat-view/chat-view'
import TaskTrayTimer from './timer-view/timer-view'

import Timer from "../../../core/gd/task-timer/timer"
import {ITEM_VIEW_CLOSE} from "../../../core/gd/app-manager/@event"
import {BUS_EVENT_TASK_VIEW_OPEN} from "../../../core/gd/task-view/@const"

type Props = {

}

type State = {
    hidden      : boolean
    minimized   : boolean
    openTaskId  : ID | null
    openChatId  : boolean
}

export default class Tray extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)

        this.state = {
            hidden      : this.getTrayItems().totalLength === 0,
            minimized   : gd.taskTray.localSettings.minimized,
            openTaskId  : null,
            openChatId  : false
        }
    }

    componentDidMount() {
        gd.bus.subscribe('task-tray:update',this,this.update);
        gd.bus.subscribe(BUS_EVENT_TASK_VIEW_OPEN,this,this.taskView);
        gd.bus.subscribe('chat:view',this,this.chatView);
        gd.bus.subscribe(ITEM_VIEW_CLOSE,this,()=>{
            this.taskView()
            this.chatView(false)
        })

        gd.bus.subscribe('task-timers:updated', this, this.update);
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this);
    }

    taskView = (taskId?: ID) => {
        this.setState({
            openTaskId: taskId || null
        })
    }

    chatView = (chatId:any) => {
        this.setState({
            openChatId: chatId
        })
    }

    update = () => {
        this.setState({
            hidden: this.getTrayItems().totalLength === 0,
            // minimized: false
        })
    }

    toggle = () =>{
        const newValue = !this.state.minimized;

        this.setState({
            minimized: newValue
        })

        gd.taskTray.localSettings.minimized = newValue
        gd.taskTray.localSettings.save()
    }

    renderMinimized() {
        const {totalLength} = this.getTrayItems()

        return (
            <div className="ui-task-tray minimized" onClick={this.toggle}>
                {totalLength}
            </div>
        )
    }

    getTrayItems() {
        let taskTrayTimers = gd.taskTimers.exportToMenuItems()
        let taskTrayTasks = gd.taskTray.getTasks()

        // remove minimized tasks which have timers
        _.map(taskTrayTimers, (timer: Timer)=>{
            if (timer.isMeeting) {
                return
            }

            const t = _.find(taskTrayTasks,{id: timer.entityId})
            if (t) {
                taskTrayTasks.remove(t)
            }
        })

        const taskTrayChats = gd.taskTray.getChats()

        return {
            taskTrayTimers,
            taskTrayTasks,
            taskTrayChats,
            totalLength: taskTrayTimers.length + taskTrayTasks.length + taskTrayChats.length
        }
    }

    renderOpen() {
        const {taskTrayTimers, taskTrayTasks, taskTrayChats} = this.getTrayItems()

        return (
            <div className="ui-task-tray open">
                {_.map(taskTrayTimers, (timer: Timer)=>
                    <TaskTrayTimer key        = {timer.entityType + ':' + timer.entityId}
                                   task       = {{id: timer.entityId, title: timer.entity.title || timer.entity.name}}
                                   entityType = {timer.entityType}
                                   isOpen     = {timer.entityId === this.state.openTaskId}/>
                )}

                {_.map(taskTrayTasks, (task:any)=>
                    <TaskTrayTask key       = {task.id}
                                  task      = {task}
                                  isOpen    = {task.id === this.state.openTaskId}/>
                )}

                {_.map(taskTrayChats, (chat:any)=>
                    <TaskTrayChat key       = {chat.id}
                                  chat      = {chat}
                                  isOpen    = {chat.id === this.state.openChatId}/>
                )}

                <div className="i5-big-angle-right" onClick={this.toggle}/>
            </div>
        )
    }

    render() {
        if (this.state.hidden) return null
        if (this.state.minimized) return this.renderMinimized()

        return this.renderOpen()
    }
}